import { render, staticRenderFns } from "./MaritalRegime.vue?vue&type=template&id=b52f691e&scoped=true"
import script from "./MaritalRegime.vue?vue&type=script&lang=js"
export * from "./MaritalRegime.vue?vue&type=script&lang=js"
import style0 from "./MaritalRegime.vue?vue&type=style&index=0&id=b52f691e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f691e",
  null
  
)

export default component.exports